import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-checked"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AppToggle',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    role: "switch",
    "aria-checked": __props.modelValue,
    class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-1", __props.modelValue ? 'bg-primary-700' : 'bg-gray-300']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !__props.modelValue)))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200", __props.modelValue ? 'translate-x-6' : 'translate-x-1'])
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})